import axios from 'axios';
import { fullURL, parseAxiosError } from '../utils';

const GENERAL_INIT = 'GENERAL_INIT';
const PLANS_SET = 'PLANS_SET';
const METAS_SET = 'METAS_SET';
const FILTERS_SET = 'FILTERS_SET';
const USER_SET = "USER_SET";
const GLOSSARY_SET = "GLOSSARY_SET";
const GLOSSARYV2_SET = "GLOSSARY_SET";
const ACTIVITY_LOG_SET = "ACTIVITY_LOG_SET";
const CURRENCY_SET = "CURRENCY_SET";
const VIDEO_TUTORIALS_SET = "VIDEO_TUTORIALS_SET";

export const initGeneral = () => ({ type: GENERAL_INIT });

export default {
  state: {
    plans: [],
    metas: [],
    filters: [],
    video_tutorials: [],
    user: {},
    glossary: null,
    glossary2: null,
    activity_log: null,
    currency: null
  },

  mutations: {
    [PLANS_SET](state, {plans}) {
      state.plans = plans;
    },
    
    [METAS_SET](state, {metas}) {
      state.metas = metas;
    },

    [FILTERS_SET](state, { filters }) {
      state.filters = filters;
    },

    [USER_SET](state, { user }) {
      state.user = user;
    },
    
    [VIDEO_TUTORIALS_SET](state, {video_tutorials}) {
      state.video_tutorials = video_tutorials;
    },

    [GLOSSARY_SET](state, { glossary }) {
      state.glossary = glossary;
    },

    [GLOSSARYV2_SET](state, {glossary2}) {
      state.glossary2 = glossary2;
    },

    [ACTIVITY_LOG_SET](state, {activity_log}) {
      state.activity_log = activity_log;
    },

    [CURRENCY_SET](state, {currency}) {
      state.currency = currency;
    }
  },

  actions: {
    [GENERAL_INIT]({commit}) {
      // const { data: plans } = axios.get("https://account.superfluid.io/api/fetch_plans");
      // commit(PLANS_SET, {plans});

      const promises = ['/plans', '/metas', '/filters', '/user', '/video_tutorials', '/dashboards/glossary/all', '/dashboards/glossary2/all','/dashboards/currency'].map(e => axios.get(fullURL(e)));
      return new Promise((resolve, reject) => {
          axios.all(promises)
            .then(axios.spread(({ data: plans }, { data: metas }, { data: filters }, { data: user }, {data: video_tutorials}, { data: glossary }, {data: glossary2}, {data: currency}) => {
              commit(PLANS_SET, { plans });
              commit(METAS_SET, { metas });
              commit(FILTERS_SET, { filters });
              commit(USER_SET, { user });
              commit(VIDEO_TUTORIALS_SET, {video_tutorials});
              commit(GLOSSARY_SET, { glossary });
              commit(GLOSSARYV2_SET, {glossary2});
              commit(CURRENCY_SET, {currency});
              resolve();
            }))
            .catch(e => reject(parseAxiosError(e)));
      });
    }
  }
}
